import React, { Component } from "react";
import { mensajeExito } from "../../generico/MensajeSistemaToast"
import MensajeUsuario from "../../generico/MensajeUsuario";
import { trackPromise } from 'react-promise-tracker';
import Popup from "react-popup";
import authService from "../../../services/login/auth.service";
import TarjetaService from "../../../services/pagos/TarjetaService"
import DatosSocio from "../../generico/DatosSocio";
import history from "../login/history";
import { splitImporte } from "../../generico/utils/FormatoInput";
import ConfigService from "../../../services/configuracion/ConfigService";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faFilePdf, faArrowLeft} from "@fortawesome/free-solid-svg-icons";


export default class TarjetaPaso4 extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }

  getInitialState = () => ({
    datosCuenta: [],
    codigoOperacion: undefined,
  })

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

  componentDidMount() {
  }

  confirmarPago(tarjeta, cuenta, importe) {
    trackPromise(
      TarjetaService.confirmarPago(tarjeta, cuenta, importe)
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);
         // console.log(jsonData)
          if (jsonData.codigoRetorno === "0") {
            this.setState({ codigoOperacion: jsonData.numeroOperacion });
            mensajeExito("El Pago de la Tarjeta se Realizó Correctamente")
            

          }
          else {
            Popup.queue(this.notifiPopup("Info", jsonData.mensajeRetorno));
            this.props.previousStep();
          }
        }
        ).catch(function (error) {
            authService.logout()
          //console.log(error)
        }));


  }
  inicio = (e) => {
    //history.push('/pagoTarjeta');
    history.push(ConfigService.getPathByName("pagoTarjeta")?.url);
    window.location.reload();
  }

  descargar = async () => {
    var vImporte=this.props.moneda + ". " + this.props.importe;
    await trackPromise(
      TarjetaService.descagarComponente("Pago de Tarjeta", this.state.codigoOperacion, authService.getSocio().numeroSocio.trim() + " - " + authService.getSocio().nombreCompleto, this.props.tarjeta + " - Tipo " + this.props.tipo, this.props.deuda, this.props.debito, "-", vImporte)
        .then((response) => {
          var fileURL = URL.createObjectURL(response.data);
          window.open(fileURL, "");         
        })
        .catch(function (error) {
          console.log(error);
        })
    );

    this.setState({ listaFactura: true });
   // return listaFactura;
  };

  render() {
    
    return (
      <div>
        <div className="row">
          <div className="steps clearfix">
            <ul role="tablist">
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text current">
                      Selección de Tarjeta
                          </span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">
                      Datos de Pago
                          </span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">
                      Datos de Verificación
                          </span>
                  </div>
                </span>
              </li>
              <li role="tab" className="current">
                <span>
                  <div className="title">
                    <span className="title_text">Confirmación</span>
                  </div>
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="row justify-content-md-center">
          <div className="col-lg-8 col-md-10">
            <p className="nro-operacion">
              Número de Operación: {this.state.codigoOperacion}
            </p>
          </div>
        </div>
        <div className="row justify-content-md-center">

          <div className="col-lg-8 col-md-10">
            <div className="form-group">
              <DatosSocio />
            </div>
            <div className="form-group">
                    <label className="input-label">Tarjeta:</label><br/> 
                    <label className="input-label-bold">{this.props.tarjeta} - Tipo {this.props.tipo} - Deuda: {this.props.deuda} GS.</label>
                  </div>  
                  <div className="form-group">
                    <label className="input-label">Cuenta Origen (a debitar):</label><br/> 
                    <label className="input-label-bold">{this.props.debito}</label>                    
                  </div> 
                  <div className="form-group">
                    <label className="input-label">Total Pagado:</label><br/> 
                    <label className="input-label-bold">{this.props.importe}</label>                    
                  </div>
                  <div className="form-group">
                    <label className="input-label">Fecha de Operación:</label><br/> 
                    <label className="input-label-bold">{ (new Date()).toLocaleDateString('es-ES', { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }) }</label>                    
                  </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <div className="row justify-content-md-center">
              <div className="col-lg-8 col-md-10">
                <MensajeUsuario tipo="INFO"
                  titulo="Recuerde."
                  mensaje="Aunque los saldos se actualicen en este sitio luego de 24 horas, los pagos de sus tarjetas Panal,
                          Cabal y Mastercard actualizan su línea de crédito disponible en el momento de la transacción." />
              </div>
            </div>
          </div>
        </div>

        <hr />
        <div className="row">
        <div className="col-lg-8 col-md-6"></div>
        <div className="col-lg-2 col-md-3 btn-consulta">
        <button
            className="btn btn-cu-quintary"
            onClick={this.inicio}> <FontAwesomeIcon icon={faArrowLeft} /> Volver a Pago de Tarjetas
          </button>
        </div>
        <div className="col-lg-2 col-md-3">
        <button className="btn btn-cu-primary" onClick={this.descargar}><FontAwesomeIcon icon={faFilePdf} /> Descargar Comprobante</button>
          <button
              hidden
              ref={(a) => (this.previousStep = a)}
              className="btn btn-cu-primary"
              onClick={this.props.previousStep}>
              </button>
        </div>
        </div>
    
      </div>
    );
  }
}